import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=b67d6356&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=ts"
export * from "./AccountStatus.vue?vue&type=script&lang=ts"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&id=b67d6356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d6356",
  null
  
)

export default component.exports